import FormInput from "app/Components/_form/FormInput/FormInput";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import QRCodeScanner from "app/Components/QRCodeScanner/QRCodeScanner";
import { initialForm, STAFF_TYPE_KEY, STAFF_TYPE_OPTION } from "./CONSTANT";
import { useForm } from "app/_helpers/hooks";
import toastr from "toastr";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { Link } from "react-router-dom";
import NoRecord from "app/Components/CommanComponents/NoRecord";

const PersonalInfo = () => {
  const [url, setUrl] = useState("");
  const [qrIsVisible, setQrIsVisible] = useState(false);
  const [isNoSearch, setIsNoSearch] = useState(true);
  const [isNoRecord, setIsNoRecord] = useState(false);
  const [searchLabel, setSearchLabel] = useState("");
  const [form, onChange, setForm] = useForm({ ...initialForm });

  console.log("form", form);

  useEffect(() => {
    setIsNoSearch(Object.values(form).some((field) => field?.trim() === ""));
  }, [form]);

  useEffect(() => {
    setSearchLabel(
      form?.staffType === STAFF_TYPE_KEY.contractorPerson
        ? "Search Aadhaar, Serial or Form A No."
        : "Search Aadhaar, Emp ID or Form A No."
    );
  }, [form?.staffType]);

  const onSearch = async () => {
    let filter = "";
    for (const key in form) {
      if (form[key] !== "") {
        filter += !filter ? `?${key}=${form[key]}` : `&${key}=${form[key]}`;
      }
    }
    const response = await CommmonService.fetchPersonalInfo(filter);
    if (!response?.status) {
      setUrl("");
      setQrIsVisible(false);
      setIsNoRecord(true);
      return toastr.error(response?.message);
    }
    const scanUrl = `/personal-info/details?data=${response?.data?.queryData}`;
    setUrl(scanUrl);
    setQrIsVisible(true);
    setIsNoRecord(false);
  };

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          { name: "Personnel Info", path: "#" },
        ]}
        breadCrumbsText="User_Management_User_Registration"
      />

      <div className="healthSafetyEnvironmentWrapper">
        <div className="p-2">
          <div className="card p-3 mt-3">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">Personnel Info</h3>
            </div>
            <div className="ehsFormWrapper">
              <Row>
                <Col lg={5}>
                  <Col lg={12}>
                    <FormSelect
                      label={"Staff Type"}
                      name="staffType"
                      value={form?.staffType}
                      onChange={onChange}
                      options={STAFF_TYPE_OPTION}
                      KEY_label={"name"}
                      KEY_value={"id"}
                      blankSelect={"Select"}
                    ></FormSelect>
                  </Col>
                  <Col lg={12}>
                    <FormInput
                      name="searchTxt"
                      onChange={onChange}
                      value={form?.searchTxt}
                      type="text"
                      label={searchLabel}
                    />
                  </Col>
                  <div className="mb-2 mt-3 text-center">
                    <Button
                      onClick={onSearch}
                      type="submit"
                      variant={isNoSearch ? "secondary" : "primary"}
                      className="m-1 text-capitalize"
                      disabled={isNoSearch}
                    >
                      Search
                    </Button>
                  </div>
                </Col>
                <Col lg={7}>
                  <div className="brdrLeft text-center">
                    {qrIsVisible ? (
                      <>
                        <QRCodeScanner url={`${window.location.origin}${url}`} />
                        <div className="mb-2 mt-3 text-center">
                          <Link
                            className="btn btn-secondary mx-2"
                            target="_blank"
                            to={url}
                          >
                            Next <BsArrowRight />
                          </Link>
                        </div>
                      </>
                    ) : isNoRecord ? (
                      <NoRecord />
                    ) : null}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
